var _defs, _line, _line2, _line3, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew329({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 2.25,
    y1: 5.5,
    x2: 13.75,
    y2: 5.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 13.75,
    y1: 2,
    x2: 13.75,
    y2: 9.01
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 2.25,
    y1: 2,
    x2: 2.25,
    y2: 9.01
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 2.25,
    y1: 5.5,
    x2: 8.27,
    y2: 11.52
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 10.75,
    y1: 9.04,
    x2: 5.79,
    y2: 14
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew329);
export default __webpack_public_path__ + "static/media/Symbolpack_New_329.7ea0b665238cff878068e069ec69ad6a.svg";
export { ForwardRef as ReactComponent };